import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-full-market',
  templateUrl: './not-full-market.component.html',
  styleUrls: ['./not-full-market.component.scss']
})
export class NotFullMarketComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
